<template>
    <div class="patient-data">

        <div class="mobile-data" :class="isMobileDataOpened ? 'opened' : ''">
            <div class="open-control" @click="isMobileDataOpened = !isMobileDataOpened">
                <svg viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="!isMobileDataOpened">
                    <path d="M1 1H19" stroke="#FFC752" stroke-width="1.5" stroke-linecap="round"/>
                    <path d="M1 8H19" stroke="#FFC752" stroke-width="1.5" stroke-linecap="round"/>
                    <path d="M1 15H19" stroke="#FFC752" stroke-width="1.5" stroke-linecap="round"/>
                </svg>
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" v-else>
                    <path d="M1 17L17 1" stroke="#FFC752" stroke-width="1.5" stroke-linecap="round"/>
                    <path d="M17 17L0.999999 1" stroke="#FFC752" stroke-width="1.5" stroke-linecap="round"/>
                </svg>
            </div>

            <div class="main-info">
                <div class="title">
                    <div class="icon">
                        <svg width="13" height="15" viewBox="0 0 27 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.5703 1.06797H13.5701C12.2977 1.06797 11.0538 1.44226 9.99572 2.14359C8.93763 2.84493 8.11282 3.84185 7.62573 5.00839C7.13863 6.17493 7.01118 7.45861 7.25951 8.69706C7.50783 9.9355 8.12077 11.073 9.02067 11.9657C9.92057 12.8584 11.067 13.4662 12.315 13.7125C13.5629 13.9587 14.8565 13.8323 16.0321 13.3493C17.2077 12.8662 18.2127 12.0481 18.9198 10.9984C19.6269 9.94857 20.0043 8.71426 20.0043 7.45153L20.0043 7.45131C20.0005 5.75923 19.3213 4.1377 18.1154 2.94146C16.9095 1.74525 15.2753 1.07172 13.5703 1.06797ZM13.5701 12.2388C12.6153 12.2388 11.682 11.9579 10.8882 11.4318C10.0945 10.9056 9.47597 10.1579 9.11075 9.28326C8.74553 8.40861 8.64999 7.44622 8.83616 6.51775C9.02234 5.58927 9.4819 4.7363 10.1569 4.06674C10.8318 3.39718 11.6919 2.94111 12.6283 2.75633C13.5647 2.57155 14.5354 2.6664 15.4174 3.02883C16.2995 3.39126 17.0532 4.00496 17.5835 4.79221C18.1137 5.57944 18.3967 6.50489 18.3967 7.45153C18.3967 8.72092 17.8884 9.93848 16.9833 10.8363C16.0782 11.7342 14.8504 12.2388 13.5701 12.2388Z" fill="white" stroke="white" stroke-width="0.2"/>
                            <path d="M0.9 23.1605V23.1866L0.912789 23.2094C2.16828 25.4471 4.00369 27.3112 6.229 28.6089C8.45431 29.9067 10.9887 30.5909 13.5699 30.5909C16.1512 30.5909 18.6856 29.9067 20.9109 28.6089C23.1362 27.3112 24.9716 25.4471 26.2271 23.2094L26.2399 23.1866V23.1605V22.4623V22.4362L26.2271 22.4134C24.9716 20.1757 23.1362 18.3116 20.9109 17.0138C18.6856 15.7161 16.1512 15.0318 13.5699 15.0318C10.9887 15.0318 8.45431 15.7161 6.229 17.0138C4.00369 18.3116 2.16828 20.1757 0.912789 22.4134L0.9 22.4362V22.4623V23.1605ZM13.5707 19.1804L11.1989 16.8276C11.9801 16.6837 12.7738 16.6167 13.5686 16.6278L13.5692 16.6278C14.3668 16.6336 15.1616 16.718 15.942 16.8795L13.5707 19.1804ZM13.0069 20.9275L13.0361 20.9565H13.0773H14.0626H14.1038L14.133 20.9275L17.7349 17.3545C20.6029 18.3301 23.0399 20.2642 24.6289 22.8254C23.4727 24.693 21.8571 26.2392 19.9332 27.3184C17.9916 28.4076 15.8008 28.9849 13.5701 28.9949C11.3428 28.9787 9.15685 28.3971 7.22037 27.3056C5.30161 26.2242 3.69112 24.6778 2.53913 22.8115C4.1235 20.2606 6.54959 18.3322 9.40511 17.3546L13.0069 20.9275Z" fill="white" stroke="white" stroke-width="0.2"/>
                        </svg>
                    </div>
                    <div class="text">
                        Дані пацієнта
                    </div>
                </div>
                <div class="content">
                    <div class="item">
                        <div class="item-name">Стать:</div>
                        <div class="item-value">{{$store.state.patient.mainInfo.gender}}</div>
                    </div>
                    <div class="item">
                        <div class="item-name">Вік:</div>
                        <div class="item-value">{{$store.state.patient.mainInfo.ageRange}}</div>
                    </div>
                    <div class="item">
                        <div class="item-name">Ім’я:</div>
                        <div class="item-value">{{$store.state.patient.mainInfo.name}}</div>
                    </div>
                </div>
            </div>

            <div class="ill-history">
                <div class="title">
                    <div class="icon">
                        <svg width="15" height="14" viewBox="0 0 33 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.75 3C0.75 1.75736 1.75736 0.75 3 0.75H30C31.2426 0.75 32.25 1.75736 32.25 3V26C32.25 27.2426 31.2426 28.25 30 28.25H3C1.75736 28.25 0.75 27.2426 0.75 26V3Z" stroke="white" stroke-width="1.5"/>
                            <path d="M13.1674 14.5H5.83257C5.09801 14.5 4.5 13.9022 4.5 13.1661V5.83387C4.5 5.10008 5.0985 4.5 5.83257 4.5H13.1674C13.9016 4.5 14.5 5.09971 14.5 5.83387V13.1661C14.5 13.9022 13.902 14.5 13.1674 14.5ZM5.83257 5.07287C5.41653 5.07287 5.07018 5.40774 5.07018 5.83387V13.1661C5.07018 13.5923 5.41653 13.9271 5.83257 13.9271H13.1674C13.584 13.9271 13.9275 13.5894 13.9275 13.1661V5.83387C13.9275 5.41001 13.583 5.07287 13.1674 5.07287H5.83257Z" fill="black" stroke="white"/>
                            <path d="M28.5763 5.31142H17.9057C17.6795 5.31142 17.5 5.12984 17.5 4.90729C17.5 4.68043 17.6807 4.5 17.9057 4.5H28.5763C28.7997 4.5 28.9825 4.68196 28.9825 4.90729C28.9825 5.12832 28.8008 5.31142 28.5763 5.31142Z" fill="black" stroke="white"/>
                            <path d="M25.5763 10.3114H17.9057C17.6795 10.3114 17.5 10.1298 17.5 9.90729C17.5 9.68043 17.6807 9.5 17.9057 9.5H25.5763C25.7997 9.5 25.9825 9.68196 25.9825 9.90729C25.9825 10.1283 25.8008 10.3114 25.5763 10.3114Z" fill="black" stroke="white"/>
                            <path d="M28.5763 15.3114H17.9057C17.6795 15.3114 17.5 15.1298 17.5 14.9073C17.5 14.6804 17.6807 14.5 17.9057 14.5H28.5763C28.7997 14.5 28.9825 14.682 28.9825 14.9073C28.9825 15.1283 28.8008 15.3114 28.5763 15.3114Z" fill="black" stroke="white"/>
                            <path d="M25.5763 20.3114H4.90571C4.67955 20.3114 4.5 20.1298 4.5 19.9073C4.5 19.6804 4.68068 19.5 4.90571 19.5H25.5763C25.7997 19.5 25.9825 19.682 25.9825 19.9073C25.9825 20.1283 25.8008 20.3114 25.5763 20.3114Z" fill="black" stroke="white"/>
                            <path d="M28.5763 25.3114H4.90571C4.67955 25.3114 4.5 25.1298 4.5 24.9073C4.5 24.6804 4.68068 24.5 4.90571 24.5H28.5763C28.7997 24.5 28.9825 24.682 28.9825 24.9073C28.9825 25.1283 28.8008 25.3114 28.5763 25.3114Z" fill="black" stroke="white"/>
                        </svg>
                    </div>
                    <div class="text">
                        Історія хвороби
                    </div>
                </div>

                <ul class="primary diagnosis" v-if="getCurrentRouteIndex > 1">
                    <div class="name">Первинна діагностика:</div>
                    <li v-if="getIPS">{{getIPS}}</li>
                    <li v-if="getIllHistoryPoints.isExtraExercise">{{getIllHistoryPoints.isExtraExercise}}</li>
                    <li v-if="getIllHistoryPoints.isBasePetKt">
                        <div v-if="getBasePetKtResult">
                            {{getIllHistoryPoints.isBasePetKt}}: {{getBasePetKtResult}}
                        </div>
                        <div v-else>
                            {{getIllHistoryPoints.isBasePetKt}}
                        </div>                        
                    </li>
                    <li v-if="getIllHistoryPoints.isBSymptoms">{{getIllHistoryPoints.isBSymptoms}}</li>
                </ul>

                <ul class="primary treatment" v-if="getPrimaryTreatmentVisible">
                    <div class="name">Попереднє лікування:</div>
                    <li v-if="getHimResult">{{getHimResult}}</li>
                </ul>

                <ul class="primary results" v-if="getPrimaryTreatmentResultsVisible">
                    <div class="name">Результати попереднього лікування:</div>
                    <li v-if="getPrimaryABVDKtResult">Динаміка по КТ: {{getPrimaryABVDKtResult}}</li>
                    <li v-if="getPrimaryPetABVDKtResult">Динаміка ПЕТ-КТ: {{getPrimaryPetABVDKtResult}}</li>
                    <li v-if="getPrimaryBEACOPPKtResult">Динаміка по КТ: {{getPrimaryBEACOPPKtResult}}</li>
                    <li v-if="getPrimaryPetBEACOPPKtResult">Динаміка ПЕТ-КТ: {{getPrimaryPetBEACOPPKtResult}}</li>
                </ul>

                <ul class="primary results" v-if="getAnamnesResult">
                    <div class="name">Виявлено в анамнезі:</div>
                    <li>{{getAnamnesResult}}</li>
                </ul>

                <ul class="primary results" v-if="getFertilAnamnesResult.length > 0">
                    <div class="name">Виявлено в анамнезі:</div>
                    <li>
                        <div v-for="(val, index) in getFertilAnamnesResult" :key="index">{{val}}<br></div>
                    </li>
                </ul>

                <ul class="primary results" v-if="getBiopsyResult">
                    <div class="name">Результат біопсії:</div>
                    <li v-if="getBiopsyResult">{{getBiopsyResult}}</li>
                </ul>
            </div>

        </div>

        <div class="main-info">
            <div class="title">
                <div class="icon">
                    <svg width="13" height="15" viewBox="0 0 27 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.5703 1.06797H13.5701C12.2977 1.06797 11.0538 1.44226 9.99572 2.14359C8.93763 2.84493 8.11282 3.84185 7.62573 5.00839C7.13863 6.17493 7.01118 7.45861 7.25951 8.69706C7.50783 9.9355 8.12077 11.073 9.02067 11.9657C9.92057 12.8584 11.067 13.4662 12.315 13.7125C13.5629 13.9587 14.8565 13.8323 16.0321 13.3493C17.2077 12.8662 18.2127 12.0481 18.9198 10.9984C19.6269 9.94857 20.0043 8.71426 20.0043 7.45153L20.0043 7.45131C20.0005 5.75923 19.3213 4.1377 18.1154 2.94146C16.9095 1.74525 15.2753 1.07172 13.5703 1.06797ZM13.5701 12.2388C12.6153 12.2388 11.682 11.9579 10.8882 11.4318C10.0945 10.9056 9.47597 10.1579 9.11075 9.28326C8.74553 8.40861 8.64999 7.44622 8.83616 6.51775C9.02234 5.58927 9.4819 4.7363 10.1569 4.06674C10.8318 3.39718 11.6919 2.94111 12.6283 2.75633C13.5647 2.57155 14.5354 2.6664 15.4174 3.02883C16.2995 3.39126 17.0532 4.00496 17.5835 4.79221C18.1137 5.57944 18.3967 6.50489 18.3967 7.45153C18.3967 8.72092 17.8884 9.93848 16.9833 10.8363C16.0782 11.7342 14.8504 12.2388 13.5701 12.2388Z" fill="white" stroke="white" stroke-width="0.2"/>
                        <path d="M0.9 23.1605V23.1866L0.912789 23.2094C2.16828 25.4471 4.00369 27.3112 6.229 28.6089C8.45431 29.9067 10.9887 30.5909 13.5699 30.5909C16.1512 30.5909 18.6856 29.9067 20.9109 28.6089C23.1362 27.3112 24.9716 25.4471 26.2271 23.2094L26.2399 23.1866V23.1605V22.4623V22.4362L26.2271 22.4134C24.9716 20.1757 23.1362 18.3116 20.9109 17.0138C18.6856 15.7161 16.1512 15.0318 13.5699 15.0318C10.9887 15.0318 8.45431 15.7161 6.229 17.0138C4.00369 18.3116 2.16828 20.1757 0.912789 22.4134L0.9 22.4362V22.4623V23.1605ZM13.5707 19.1804L11.1989 16.8276C11.9801 16.6837 12.7738 16.6167 13.5686 16.6278L13.5692 16.6278C14.3668 16.6336 15.1616 16.718 15.942 16.8795L13.5707 19.1804ZM13.0069 20.9275L13.0361 20.9565H13.0773H14.0626H14.1038L14.133 20.9275L17.7349 17.3545C20.6029 18.3301 23.0399 20.2642 24.6289 22.8254C23.4727 24.693 21.8571 26.2392 19.9332 27.3184C17.9916 28.4076 15.8008 28.9849 13.5701 28.9949C11.3428 28.9787 9.15685 28.3971 7.22037 27.3056C5.30161 26.2242 3.69112 24.6778 2.53913 22.8115C4.1235 20.2606 6.54959 18.3322 9.40511 17.3546L13.0069 20.9275Z" fill="white" stroke="white" stroke-width="0.2"/>
                    </svg>
                </div>
                <div class="text">
                    Дані пацієнта
                </div>
            </div>

            <div class="content">
                <div class="item">
                    <div class="item-name">Стать:</div>
                    <div class="item-value">{{$store.state.patient.mainInfo.gender}}</div>
                </div>
                <div class="item">
                    <div class="item-name">Вік:</div>
                    <div class="item-value">{{$store.state.patient.mainInfo.ageRange}}</div>
                </div>
                <div class="item">
                    <div class="item-name">Ім’я:</div>
                    <div class="item-value">{{$store.state.patient.mainInfo.name}}</div>
                </div>
            </div>
        </div>

        <div class="ill-history">
            <div class="title">
                    <div class="icon">
                    <svg width="15" height="14" viewBox="0 0 33 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.75 3C0.75 1.75736 1.75736 0.75 3 0.75H30C31.2426 0.75 32.25 1.75736 32.25 3V26C32.25 27.2426 31.2426 28.25 30 28.25H3C1.75736 28.25 0.75 27.2426 0.75 26V3Z" stroke="white" stroke-width="1.5"/>
                        <path d="M13.1674 14.5H5.83257C5.09801 14.5 4.5 13.9022 4.5 13.1661V5.83387C4.5 5.10008 5.0985 4.5 5.83257 4.5H13.1674C13.9016 4.5 14.5 5.09971 14.5 5.83387V13.1661C14.5 13.9022 13.902 14.5 13.1674 14.5ZM5.83257 5.07287C5.41653 5.07287 5.07018 5.40774 5.07018 5.83387V13.1661C5.07018 13.5923 5.41653 13.9271 5.83257 13.9271H13.1674C13.584 13.9271 13.9275 13.5894 13.9275 13.1661V5.83387C13.9275 5.41001 13.583 5.07287 13.1674 5.07287H5.83257Z" fill="black" stroke="white"/>
                        <path d="M28.5763 5.31142H17.9057C17.6795 5.31142 17.5 5.12984 17.5 4.90729C17.5 4.68043 17.6807 4.5 17.9057 4.5H28.5763C28.7997 4.5 28.9825 4.68196 28.9825 4.90729C28.9825 5.12832 28.8008 5.31142 28.5763 5.31142Z" fill="black" stroke="white"/>
                        <path d="M25.5763 10.3114H17.9057C17.6795 10.3114 17.5 10.1298 17.5 9.90729C17.5 9.68043 17.6807 9.5 17.9057 9.5H25.5763C25.7997 9.5 25.9825 9.68196 25.9825 9.90729C25.9825 10.1283 25.8008 10.3114 25.5763 10.3114Z" fill="black" stroke="white"/>
                        <path d="M28.5763 15.3114H17.9057C17.6795 15.3114 17.5 15.1298 17.5 14.9073C17.5 14.6804 17.6807 14.5 17.9057 14.5H28.5763C28.7997 14.5 28.9825 14.682 28.9825 14.9073C28.9825 15.1283 28.8008 15.3114 28.5763 15.3114Z" fill="black" stroke="white"/>
                        <path d="M25.5763 20.3114H4.90571C4.67955 20.3114 4.5 20.1298 4.5 19.9073C4.5 19.6804 4.68068 19.5 4.90571 19.5H25.5763C25.7997 19.5 25.9825 19.682 25.9825 19.9073C25.9825 20.1283 25.8008 20.3114 25.5763 20.3114Z" fill="black" stroke="white"/>
                        <path d="M28.5763 25.3114H4.90571C4.67955 25.3114 4.5 25.1298 4.5 24.9073C4.5 24.6804 4.68068 24.5 4.90571 24.5H28.5763C28.7997 24.5 28.9825 24.682 28.9825 24.9073C28.9825 25.1283 28.8008 25.3114 28.5763 25.3114Z" fill="black" stroke="white"/>
                    </svg>
                </div>
                <div class="text">
                    Історія хвороби
                </div>
            </div>

            <ul class="primary diagnosis" v-if="getCurrentRouteIndex > 1">
                <div class="name">Первинна діагностика:</div>
                <li v-if="getIPS">{{getIPS}}</li>
                <li v-if="getIllHistoryPoints.isExtraExercise">{{getIllHistoryPoints.isExtraExercise}}</li>
                <li v-if="getIllHistoryPoints.isBasePetKt">
                    <div v-if="getBasePetKtResult">
                        {{getIllHistoryPoints.isBasePetKt}}: {{getBasePetKtResult}}
                    </div>
                    <div v-else>
                        {{getIllHistoryPoints.isBasePetKt}}
                    </div>                        
                </li>
                <li v-if="getIllHistoryPoints.isBSymptoms">{{getIllHistoryPoints.isBSymptoms}}</li>
            </ul>

            <ul class="primary treatment" v-if="getPrimaryTreatmentVisible">
                <div class="name">Попереднє лікування:</div>
                <li v-if="getHimResult">{{getHimResult}}</li>
            </ul>

            <ul class="primary results" v-if="getPrimaryTreatmentResultsVisible">
                <div class="name">Результати попереднього лікування:</div>
                <li v-if="getPrimaryABVDKtResult">Динаміка по КТ: {{getPrimaryABVDKtResult}}</li>
                <li v-if="getPrimaryPetABVDKtResult">Динаміка ПЕТ-КТ: {{getPrimaryPetABVDKtResult}}</li>
                <li v-if="getPrimaryBEACOPPKtResult">Динаміка по КТ: {{getPrimaryBEACOPPKtResult}}</li>
                <li v-if="getPrimaryPetBEACOPPKtResult">Динаміка ПЕТ-КТ: {{getPrimaryPetBEACOPPKtResult}}</li>
            </ul>

            <ul class="primary results" v-if="getAnamnesResult">
                <div class="name">Виявлено в анамнезі:</div>
                <li>{{getAnamnesResult}}</li>
            </ul>

            <ul class="primary results" v-if="getFertilAnamnesResult.length > 0">
                <div class="name">Виявлено в анамнезі:</div>
                <li>
                    <div v-for="(val, index) in getFertilAnamnesResult" :key="index">{{val}}<br></div>
                </li>
            </ul>

            <ul class="primary results" v-if="getBiopsyResult">
                <div class="name">Результат біопсії:</div>
                <li v-if="getBiopsyResult">{{getBiopsyResult}}</li>
            </ul>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    computed : {
        ...mapGetters([
            'getCurrentRouteIndex',
            'getPrimaryTreatmentVisible',
            'getPrimaryTreatmentResultsVisible',
            'getIPS',
            'getIllHistoryPoints',
            'getBasePetKtResult',
            'getHimResult',
            'getPrimaryABVDKtResult',
            'getPrimaryBEACOPPKtResult',
            'getPrimaryPetABVDKtResult',
            'getPrimaryPetBEACOPPKtResult',
            'getBiopsyResult',
            'getAnamnesResult',
            'getFertilAnamnesResult'
        ])
    },
    data : () => ({
        isMobileDataOpened : false
    }),
    methods : {
        getEventId(){
            return sessionStorage.getItem('eventId');
        }
    }
}
</script>

<style lang="scss">
ul{
    margin: 0;
    padding: 0;
    text-align: left;

    li{
        div{
            display: inline;
        }
    }
}

.patient-data{
    width: 20%;
    height: calc(100% - 44px);

    padding: 22px 20px 22px 20px;

    background: rgba(0, 96, 126, 0.7);

    .mobile-data{
        display: none;
    }

    .title{
        display: flex;
        flex-direction: row;
        align-items: center;

        padding-bottom: 16px;

        .icon{
            margin-right: 7px;
        }

        .text{
            font-style: normal;
            font-weight: bold;
            font-size: 14px;
            

            color: #FFFFFF;
            padding-bottom: 4px;
        }
    }

    .main-info{
        border-bottom: 1px solid rgba(255, 255, 255, 0.5);
        padding-bottom: 7px;
        margin-bottom: 16px;

        .content{
            display: flex;
            flex-direction: column;

            padding: 0;

            .item{
                display: flex;
                flex-direction: row;
                justify-content: flex-start;

                padding: 0;
                padding-bottom: 8px;

                .item-name{
                    font-style: normal;
                    font-weight: 300;
                    font-size: 10px;
                    line-height: 14px;

                    color: #FFFFFF;

                    padding: 0;
                    padding-right: 12px;

                    text-align: left;
                    min-width: 32px;
                }

                .item-value{
                    font-style: normal;
                    font-weight: bold;
                    font-size: 10px;
                    line-height: 14px;

                    color: #FFFFFF;

                    text-align: left;
                    padding: 0;
                }
            }
        }
    }

    .ill-history{
        .primary{
            display: flex;
            flex-direction: column;
            align-content: flex-start;

            color: #FFFFFF;
            font-size: 10px;
            line-height: 14px;

            padding-bottom: 18px;

            .name{
                font-weight: 300;                
                padding-bottom: 10px;
            }

            li{
                margin-left: 15px;
                font-weight: bold;
                padding-right: 10px;
            }
        }
    }
}

@media (min-width: 1024px) and (min-aspect-ratio: 16/9) {
    .patient-data{
        width: 15.104vw;
        height: calc(100% - 2.083vw - 2.083vw);

        padding: 2.083vw 1.667vw;

        .title{
            padding-bottom: 1.250vw;

            .icon{
                margin-right: 0.677vw;

                svg{
                    height: 1.198vw;
                    width: auto;
                }
            }

            .text{
                font-size: 1.042vw;
            }
        }

        .main-info{
            padding-bottom: 0.938vw;
            margin-bottom: 0.833vw;

            .content{
                .item{
                    padding-bottom: 0.938vw;

                    .item-name{
                        font-size: 0.938vw;
                        line-height: 0.938vw;

                        padding-right: 12px;
                        min-width: 3.5vw;
                    }

                    .item-value{
                        font-size: 0.938vw;
                        line-height: 0.938vw;
                    }
                }
            }
        }

        .ill-history{
            .primary{
                font-size: 0.938vw;
                line-height: 1.354vw;

                padding-bottom: 0.938vw;

                .name{           
                    padding-bottom: 0.521vw;
                }

                li{
                    margin-left: 0.781vw;
                    padding-right: 0.521vw;
                }
            }
        }
    }
}

@media (min-width: 1024px) and (min-aspect-ratio: 21/9) {
     .patient-data{
        width: 12vw;

        padding: 2.083vw 1.2vw;

        .title{
            padding-bottom: 1vw;

            .icon{
                margin-right: 0.5vw;

                svg{
                    height: 0.9vw;
                }
            }

            .text{
                font-size: 0.9vw;
            }
        }

        .main-info{
            padding-bottom: 0.5vw;
            margin-bottom: 0.6vw;

            .content{
                .item{
                    padding-bottom: 0.6vw;

                    .item-name{
                        font-size: 0.8vw;
                        line-height: 0.8vw;

                        padding-right: 12px;
                        min-width: vw;
                    }

                    .item-value{
                        font-size: 0.8vw;
                        line-height: 0.8vw;
                    }
                }
            }
        }

        .ill-history{
            .primary{
                font-size: 0.7vw;
                line-height: 1.2vw;

                padding-bottom: 0.5vw;

                .name{           
                    padding-bottom: 0.5vw;
                }

                li{
                    margin-left: 0.781vw;
                    padding-right: 0.521vw;
                }
            }
        }
    }
}

@media (max-width: 599px){
    .patient-data{
        overflow: hidden;
        width: 10.833vw;
        min-width: 10.833vw;

        height: 100%;
        padding: 0;

        .mobile-data{
            display: flex;
            flex-direction: column;
            align-items: center;
            padding-top: 6.111vw;

            .open-control{
                svg{
                    width: 5.556vw;
                }
            }
            
            .main-info, .ill-history{
                display: flex;
                justify-content: center;
                padding-top: 9.167vw;
                width: calc(7% - 5.556vw);
                padding: 9.167vw 2.778vw 3.889vw;

                .content{
                    display: none;
                }

                .title{
                    padding: 0;

                    .icon{
                        margin-right: 0;

                        svg{
                            width: 4.722vw;
                            height: auto;
                        }
                    }

                    .text{
                        display: none;
                    }
                }
            }

            .ill-history{
                padding-top: 0;

                .title{
                    .icon{
                        svg{
                            width: 5.139vw;
                        }
                    }
                }

                .primary{
                    display: none;
                }
            }
        }

        .opened{
            position: fixed;
            top: 0;
            left: 0;
            width: calc(91.389vw - 2.778vw - 2.778vw);
            height: 100%;
            z-index: 10;

            background: rgba(0, 96, 126, 0.9);

            align-items: flex-start;
            padding-left: 2.778vw;
            padding-right: 2.778vw;

            .open-control{
                svg{
                    width: 4.444vw;
                }
            }

            .main-info, .ill-history{
                padding: 0;
                width: 100%;

                justify-content: flex-start;
                flex-direction: column;

                border-bottom: none;

                .title{
                    padding-bottom: 2.222vw;

                    .icon{
                        margin-right: 3.611vw;
                    }
                    
                    .text{
                        display: block;
                        font-size: 5.556vw;
                    }

                    border-bottom: 1px solid rgba(255, 255, 255, 0.5);
                }

                .content{
                    display: block;
                    flex-direction: column;

                    padding-top: 4.444vw;
                    padding-left: 11.111vw - 2.778vw;

                    .item{
                        align-items: center;

                        .item-name{
                            font-size: 3.889vw;
                            line-height: 5.278vw;

                            width: 12.500vw;
                        }

                        .item-value{
                            font-size: 3.889vw;
                            line-height: 5.278vw;
                        }
                    }
                }
            }

            .main-info{
                padding-top: 9.167vw;
            }

            .ill-history{

                .primary{
                    display: flex;

                    padding-left: 11.111vw - 2.778vw;

                    font-size: 3vw;
                    line-height: 4vw;

                    padding-bottom: 3vw;

                    .name{               
                        padding-bottom: 1.5vw;
                    }

                    li{
                        margin-left: 4.167vw;
                        padding-right: 2.778vw;
                        padding-bottom: 1vw;
                    }
                }

                .diagnosis{
                    padding-top: 4.444vw;
                }
            }
        }

        .main-info{
            display: none;
        }

        .ill-history{
            display: none;
        }
    }
}
</style>